import { useEffect } from 'react'
import { useReward } from 'react-rewards'
import { NewHabitType } from './TargetScores'

interface ConfejjiProps {
  type: NewHabitType
}

const Confejji = ({ type }: ConfejjiProps) => {
  const emojiGroups = {
    sleep: '🐑',
    fitness: '💪',
    nutrition: '🥗',
    personalChallenge: '🧘🏻‍♀️',
    plannedDay: '🎯',
    miw: '🚀',
    love: '❤️',
  }
  const { reward: showConfejji } = useReward('confejjiDiv', 'emoji', {
    emoji: [emojiGroups[type], '💯'],
    startVelocity: 15,
    decay: 0.96,
  })

  useEffect(() => showConfejji(), [])

  return <div id="confejjiDiv"></div>
}

export default Confejji
